import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
import { MarkdownOrText } from "../../Common";
import { SubconfigurationCompleteIndicatorIcon } from "./SubconfigurationCompleteIndicator";
const Stepper = lazy(() => import("@mui/material/Stepper"));
const Step = lazy(() => import("@mui/material/Step"));
const StepButton = lazy(() => import("@mui/material/StepButton"));
/**
 * Tab control on configuration level
 * @category UI
 * @param props
 * @returns
 */
export function SubconfigurationStepperNavigation(props) {
    const { items, activePath, setActivePath: setActiveItem, navigationStyle, textMode, } = props;
    const activeItemIndex = items.findIndex((item) => item.path === activePath);
    return (_jsx(Suspense, { children: _jsx(Stepper, Object.assign({ nonLinear: true, orientation: props.orientation, activeStep: activeItemIndex, sx: navigationStyle }, props.stepperProps, { children: items.map((item, itemIndex) => {
                const isActive = itemIndex === activeItemIndex;
                const color = isActive ? "primary" : "disabled";
                return (_jsx(Step, { completed: item.isComplete, children: _jsx(StepButton, { color: color, onClick: () => {
                            setActiveItem(item.path);
                        }, icon: _jsx(SubconfigurationCompleteIndicatorIcon, { completed: item.isComplete, color: color }), children: _jsx(MarkdownOrText, { text: item.label, textMode: textMode }) }) }, item.path));
            }) })) }));
}
//# sourceMappingURL=SubconfigurationStepperNavigation.js.map